import { localCache } from './cache'

//检查浏览器版本Chrome <87、Firefox <78、Safari <14、Edge <88 或 IE11 及更低版本
export function checkBrowser() {
  let result = true
  const ua = navigator.userAgent
  const isIE = /MSIE|Trident/.test(ua)
  const isEdgeLegacy = /Edg\//.test(ua) && parseInt(RegExp.$1) < 88 // Edge <88 的旧版本
  const isChromeOld = /Chrome\/(\d+)/.test(ua) && parseInt(RegExp.$1) < 87
  const isFirefoxOld = /Firefox\/(\d+)/.test(ua) && parseInt(RegExp.$1) < 78
  const isSafariOld = /Version\/(\d+).+Safari/.test(ua) && parseInt(RegExp.$1) < 14

  if (isIE || isEdgeLegacy || isChromeOld || isFirefoxOld || isSafariOld) {
    result = false
  }

  return result
}

//pro专业版，common普通版
export function getVersionType() {
  const versionType = sessionStorage.getItem('versionType') || null
  return versionType
}

export function setVersionType(value) {
  sessionStorage.setItem('versionType', value)
}

export function checkLogin() {
  return localCache.getCache('USER') && localCache.getCache('TOKEN')
}
